"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _customPropTypes = require("../../customPropTypes");

var _FeIcon = _interopRequireDefault(require("./FeIcon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var FeLabel = function FeLabel(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      isTransparent = _ref.isTransparent,
      onClick = _ref.onClick,
      className = _ref.className,
      options = _objectWithoutProperties(_ref, ["children", "icon", "isTransparent", "onClick", "className"]);

  var classes = (0, _classnames.default)('fe-label', {
    'fe-label--icon': icon,
    'fe-label--background': !isTransparent,
    'fe-btn': onClick
  }, className);

  var labelProps = _objectSpread({}, options, {
    className: classes,
    onClick: onClick,
    role: onClick ? 'button' : undefined,
    tabIndex: onClick ? 0 : undefined
  });

  return _react.default.createElement("div", labelProps, icon && _react.default.createElement(_FeIcon.default, {
    icon: icon.name,
    family: icon.family,
    className: "fe-label__icon fe-icon--left"
  }), children);
};

FeLabel.defaultProps = {
  isTransparent: false
};
FeLabel.propTypes = {
  /** The contents for the label (required) */
  children: _propTypes.default.node.isRequired,

  /** Provide the icon name and family in shape of { name: 'name', family: 'solid' }*/
  icon: _customPropTypes.iconPropType,

  /** Set true/false to make transparent background*/
  isTransparent: _propTypes.default.bool,

  /** click event handler */
  onClick: _propTypes.default.func,

  /** Optional additional CSS classes */
  className: _propTypes.default.string
};
var _default = FeLabel;
exports.default = _default;